import * as React from 'react';
import './draggableCard.scss';
import { Icon } from 'rcd-cpp-ui/ui/icon';
import { Metadata } from '../../types';
import { dndCardDetails } from '../../utils';
import { SixDots, TrashSmallGrey } from '../Icon/icon';

type DraggableCardProps = {
  card: Metadata;
  index: number;
  onMove: (dragIndex: number, hoverIndex: number) => void;
  isCurrent: boolean;
  onRemove: (card: Metadata) => void;
};

export const DraggableCard = ({
  card,
  index,
  onMove,
  isCurrent = false,
  onRemove
}: Readonly<DraggableCardProps>) => {
  const { ref, opacity, handlerId } = dndCardDetails(
    onMove,
    card.props.refId,
    index
  );

  return (
    <div className="cards-container">
      <div
        ref={ref}
        className={`draggable-card ${isCurrent ? 'draggable-card-current' : ''}`}
        style={{ opacity }}
        data-handler-id={handlerId}
      >
        <div className="draggable-card-number">{index + 1}</div>
        <div
          className="draggable-card-title"
          title={card.props.title ?? 'Untitled'}
        >
          {card.props.title ?? <i>Untitled</i>}
          {isCurrent && <span className="current-badge"> (Current)</span>}
        </div>
        <div className="draggable-card-drag-handle">
          <SixDots />
        </div>
      </div>
      {onRemove && (
        <Icon onClick={() => onRemove(card)} className="draggable-card-trash">
          <TrashSmallGrey />
        </Icon>
      )}
    </div>
  );
};
